'use strict';

/**
 * Bambuser Shopper Events Tracker
 *
 * Loads the Bambuser metrics CDN and exposes helpers that queue events until
 * the library is ready.  Events are only sent when the _bamls_lcte cookie
 * exists (set automatically by any Bambuser player embed).
 */

var METRICS_SRC = 'https://cdn.liveshopping.bambuser.com/metrics/bambuser-eu.min.js';
var CUSTOM_ATTR = 'data-bambuser-event';

// ---- internal queue --------------------------------------------------

var queuedEvents = [];
var scriptLoading = false;

function flushQueue () {
    if (!window._bambuser || typeof window._bambuser.track !== 'function') {
        return;
    }

    for (var i = 0; i < queuedEvents.length; i++) {
        window._bambuser.track(queuedEvents[i].eventType, queuedEvents[i].eventData);
    }

    queuedEvents = [];
}

function ensureScript () {
    if (window._bambuser && typeof window._bambuser.track === 'function') {
        flushQueue();
        return;
    }

    if (scriptLoading) {
        return;
    }

    scriptLoading = true;

    var script = document.createElement('script');
    script.src = METRICS_SRC;
    script.async = true;
    script.onload = function () {
        flushQueue();
    };
    document.head.appendChild(script);
}

// ---- public API -------------------------------------------------------

function track (eventType, eventData) {
    if (window._bambuser && typeof window._bambuser.track === 'function') {
        window._bambuser.track(eventType, eventData);
        return;
    }

    queuedEvents.push({ eventType: eventType, eventData: eventData });
    ensureScript();
}

// ---- event helpers ----------------------------------------------------

/**
 * Build a Bambuser ProductObject from a raw SFCC cart/order line item.
 */
function mapProduct (item, currency, isBambuserItem) {
    var pid = item.id || '';
    var baseId = pid.split('_')[0].split(' ')[0];

    var product = {
        id: baseId,
        name: item.productName || item.nameEng || '',
        quantity: item.quantity || 1,
        price: item.price && item.price.sales ? item.price.sales.value : 0,
        currency: currency || 'EUR',
        isBambuserItem: isBambuserItem || false,
    };

    if (item.images && item.images.small && item.images.small[0]) {
        product.image = item.images.small[0].absURL || item.images.small[0].url || '';
    }

    if (item.price && item.price.list && item.price.sales) {
        product.discount = parseFloat((item.price.list.value - item.price.sales.value).toFixed(2));
    }

    if (item.categoryPath) {
        product.category = item.categoryPath;
    }

    product.location = window.location.origin + '/' + baseId + '.html';

    return product;
}

/**
 * Track an add-to-cart event.
 * Called after product:afterAddToCart fires.
 */
function trackAddToCart (items, currency, isBambuserItem) {
    var products = [];

    for (var i = 0; i < items.length; i++) {
        products.push(mapProduct(items[i], currency, isBambuserItem));
    }

    track('add-to-cart', { products: products });
}

/**
 * Track an update-cart event (quantity change or removal).
 */
function trackUpdateCart (items, currency, isBambuserItem) {
    var products = [];

    for (var i = 0; i < items.length; i++) {
        products.push(mapProduct(items[i], currency, isBambuserItem));
    }

    track('update-cart', { products: products });
}

/**
 * Track a product-view event.
 */
function trackProductView (items, currency, isBambuserItem) {
    var products = [];

    for (var i = 0; i < items.length; i++) {
        products.push(mapProduct(items[i], currency, isBambuserItem));
    }

    track('product-view', { products: products });
}

/**
 * Track a purchase event.
 * @param {Object} transaction  - Bambuser TransactionObject
 * @param {Array}  products     - Array of Bambuser ProductObjects
 */
function trackPurchase (transaction, products) {
    track('purchase', {
        transaction: transaction,
        products: products,
    });
}

/**
 * Track a refund event.
 * Called when a customer initiates a refund for one or more products.
 * @param {Object} transaction  - Bambuser TransactionObject with refund details
 * @param {Array}  products     - Array of Bambuser ProductObjects being refunded
 */
function trackRefund (transaction, products) {
    track('refund', {
        transaction: transaction,
        products: products,
    });
}

module.exports = {
    CUSTOM_ATTR: CUSTOM_ATTR,
    track: track,
    mapProduct: mapProduct,
    trackAddToCart: trackAddToCart,
    trackUpdateCart: trackUpdateCart,
    trackProductView: trackProductView,
    trackPurchase: trackPurchase,
    trackRefund: trackRefund,
};
